import React from 'react';
import {useOutletContext} from 'react-router-dom';
import WearHistory from '../components/WearHistory';
import type {ItemPageContext} from './ClothingItemDetail';

const ItemHistoryTab: React.FC = () => {
    const {item, itemId, selectedOwnerId, canEdit, refreshItem} = useOutletContext<ItemPageContext>();

    return (
        <WearHistory
            itemId={itemId}
            ownerId={selectedOwnerId}
            reloadKey={item.totalWears ?? 0}
            canEdit={canEdit}
            onWearDeleted={refreshItem}
        />
    );
};

export default ItemHistoryTab;
